import axios from 'axios';

/**
 * Read firebase user and return the token as a promise
 * @returns {Promise<null|{headers: {Authorization: string}}>}
 */
export const createHeader = async () => {
  const token = localStorage.getItem('access_token');
  if (token) {
    return {
      headers: {
        Authorization: `Bearer ${token}`
      }
    };
  }

  return null;
};

/**
 *
 * @param route
 * @param data
 * @returns {Promise<AxiosResponse<any>>}
 */
const post = async (route, data) => {
  try {
    // get header
    const config = await createHeader();
    // axios post method
    const reqData = await axios.post(
      `${route}`,
      {
        ...data
      },
      config
    );
    return reqData;
  } catch (error) {
    if(error.response && error.response.status === 401) {
      localStorage.clear();
      logout();
    }
    else{
      throw error;
    }
  }
};

/**
 *
 * @param route
 * @param data
 * @returns {Promise<AxiosResponse<any>>}
 */
const postFormData = async (route, data) => {
  try {
    // get header
    const config = await createHeader();
    // axios post method
    const reqData = await axios.post(`${route}`, data, config);
    return reqData;
  } catch (error) {
    if(error.response && error.response.status === 401) {
      localStorage.clear();
      logout();
    }
    else{
      throw error;
    }
  }
};

/**
 *
 * @param route
 * @param data
 * @returns {Promise<AxiosResponse<any>>}
 */
const put = async (route, data) => {
  try {
    // get header
    const config = await createHeader();
    // axios put method
    const reqData = await axios.put(
      `${route}`,
      {
        ...data
      },
      config
    );
    return reqData;
  } catch (error) {
    if(error.response && error.response.status === 401) {
      localStorage.clear();
      logout();
    }
    else{
      throw error;
    }
  }
};

const remove = async (route, data?: any) => {
  try {
    // get header
    const config = await createHeader();
    // axios delete method
    const reqData = await axios.delete(`${route}`, {
      headers: {
        Authorization: config?.headers?.Authorization
      },
      data
    });
    return reqData;
  } catch (error) {
    if(error.response && error.response.status === 401) {
      localStorage.clear();
      logout();
    }
    else{
      throw error;
    }
  }
};

const get = async (route, type?: any) => {
  try {
    // get header
    const config = await createHeader();
    // axios get method
    const reqData = await axios.get(`${route}`, {
      headers: {
        Authorization: config?.headers?.Authorization
      },
      responseType: type
    });
    return reqData;
  } catch (error) {
    if(error.response && error.response.status === 401) {
      localStorage.clear();
      logout();
    }
    else{
      throw error;
    }
  }
};

/**
 * @param route
 * @param data
 * @returns {Promise<AxiosResponse<any>>}
 */
const postAttachmentData = async (route, data) => {
  try {
     // Get the authorization header
     const authHeader = await createHeader();

     // Merge the authorization header with other headers
    const headers = {
      'Content-Type': 'multipart/form-data',
      ...(authHeader ? authHeader.headers : {})
    };

    // axios post method
    const response = await axios({
      method: 'post',
      url: route,
      data: data,
      headers: headers
    });
    return response;
  } catch (error) {
    if(error.response && error.response.status === 401) {
      localStorage.clear();
      logout();
    }
    else{
      throw error;
    }
  }
};

const postWithDownloadFile = async (route, data, type?: any) => {
  try {
    // get header
    const config = await createHeader();
    // axios post method
    const reqData = await axios.post(
      `${route}`,
      {
        ...data
      },
      {
        headers: {
          Authorization: config?.headers?.Authorization,
          'Content-Type': 'application/json'
        },
        responseType: type
      }
    );
    return reqData;
  } catch (error) {
    if(error.response && error.response.status === 401) {
      localStorage.clear();
      logout();
    }
    else{
      throw error;
    }
  }
};

//genarate random token
const rand = () => {
  return Math.random().toString(36).substr(2); // remove `0.`
};

const token = () => {
  return rand() + rand(); // to make it longer
};

//Logout function
const logout = () => {
  const ran_token = token();
  localStorage.setItem('token', ran_token);
  window.location.href = '/unauthorized/' + ran_token;
  
}

/**
 *
 * @param route
 * @param data
 * @returns {Promise<AxiosResponse<any>>}
 */
const patch = async (route, data) => {
  try {
    // get header
    const config = await createHeader();
    // axios patch method
    const reqData = await axios.patch(
      `${route}`,
      {
        ...data
      },
      config
    );
    return reqData;
  } catch (error) {
    if (error.response && error.response.status === 401) {
      localStorage.clear();
      logout();
    } else {
      throw error;
    }
  }
};

export { post, postFormData, remove, put, get, postAttachmentData, logout, postWithDownloadFile,patch};
